import {
  LOAD_AUTH_INFO,
  LOG_OUT,
} from './auth_types';

import {
  axiosInstnace, getLocalData,
  getUserData, getAdminData,
  removeData
} from '../util/util';

import { history } from '../history/history';

export const loadAdminAuthData= ()=> {
  const adminInfo= getAdminData();
  if(adminInfo) {
    let { token }= adminInfo;
    let headers= {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    };
    axiosInstnace.defaults.headers= headers;
  }
}

export const loadUserAuthData= ()=> {
  const userInfo= getUserData();
  if(userInfo) {
    let { token }= userInfo;
    let headers= {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    };
    axiosInstnace.defaults.headers= headers;
  }
}

export const loadSalesUserAuthData= ()=> {
  const salesUserInfo= getLocalData('salesUserInfo');
  if(salesUserInfo) {
    let { token }= salesUserInfo;
    let headers= {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    };
    axiosInstnace.defaults.headers= headers;
  }
}

export const loadAuthData = () => {
  const userInfo = getUserData();
  if (userInfo) {
    const { token } = userInfo;
    axiosInstnace.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
};

export const logOut = () => dispatch => {
  dispatch({
    type: LOG_OUT
  });
  removeData('userInfo');
  history.push('/login');
};





// WEBPACK FOOTER //
// ./web/action/auth_action.jsx